import React from "react";
import { Route } from "react-router-dom";
import StudentData from "../Modules/Admin/Screens/Student_Creation/Students";
import StudentInfo from "../Modules/Admin/Screens/Student_Creation/StudentInfo";
import AllStudentsInCampus from "../Modules/Admin/Screens/Student_Creation/AllStudentsInCampus";
import StaffMyProfile from "../Modules/Admin/Screens/Staffs/StaffMyProfile";
import ReportsClusterListing from "../Modules/Admin/Screens/Reports/ReportsClusterListing";
import ClusterReport from "../Modules/Admin/Screens/Reports/ClusterReport";
import HomePage from "../Modules/HomePage";
import AssignmentListing from "../Modules/Admin/Screens/Reports/AssignmentListing";
import AssignmentReport from "../Modules/Admin/Screens/Reports/AssignmentReport";
import AssignmentCampusListing from "../Modules/Admin/Screens/Reports/AssignmentCampusListing";
import StudentDashboard from "../Modules/Student";
import { elements } from "chart.js";
import AssignmentNotAttendee from "../Modules/Admin/Screens/Reports/AssignmentNotAttendee";
import ModuleCampusListing from "../Modules/Admin/Screens/Module/ModuleCampusListing";
import ModuleListing from "../Modules/Admin/Screens/Module/ModuleListing";
import ModuleReport from "../Modules/Admin/Screens/Module/ModuleReport";
import ReportList from "../Modules/Admin/Screens/Module/ReportList";
import ModuleNotAttended from "../Modules/Admin/Screens/Module/ModuleNotAttended";
import AssignmentScores from "../Modules/Admin/Screens/Student_Creation/AssignmentScores";
import StaffAssignmentReport from "../Modules/Admin/Screens/Student_Creation/StaffAssignmentReport";
import StudentsNotAttended from "../Modules/Admin/Screens/Student_Creation/StudentsNotAttended";
import WorkInstructionSlide from "../Modules/Admin/Screens/Student_Creation/WorkInstructionSlide.jsx";
import StudentLookup from "../Modules/Admin/Screens/Reports/StudentLookup.jsx";

const adminRoutes = [
  <Route
    key="students-data"
    path="/admin/students"
    element={<StudentData />}
  />,
   <Route
    key="staff-data-instruction"
    path="/staff-data-instruction"
    element={<WorkInstructionSlide />}
  />,
  <Route
    key="student-details"
    path="/admin/student-details/:id"
    element={<StudentInfo />}
  />,
  <Route
    key="all-students-in-campus"
    path="/admin/student-details"
    element={<AllStudentsInCampus />}
  />,
  <Route key="all-students-in-campus" path="/assignment/:assignmentId" element={<AssignmentScores />} />,

  <Route
    key="admin/assignment-report"
    path="admin/assignment-report"
    element={<StaffAssignmentReport />}
  />,

   <Route
    key="admin/assignment-report/notAttendee"
    path="admin/assignment-report/notAttendee"
    element={<StudentsNotAttended />}
  />,
  <Route
    key="admin/individual-report"
    path="admin/individual-report"
    element={<StudentLookup />}
  />,
  <Route
    key="staff-my-profile"
    path="/staff/my-profile"
    element={<StaffMyProfile />}
  />,
  <Route
    key="student-dashboard"
    path="/admin/student/:studentid"
    element={<StudentDashboard isAdmin={true} />}
  />,
  <Route
    key="assignment-listing"
    path="admin/reports/assignments/:campusName"
    element={<AssignmentListing />}
  />,
  <Route
    key="assignment-campus-listing-root"
    path="admin/reports/assignments"
    element={<AssignmentCampusListing />}
  />,
  <Route
    key="assignment-report"
    path="admin/reports/assignments/:campusName/:assignment_id"
    element={<AssignmentReport />}
  />,
   <Route
      key="module-campus-listing"
      path="/admin/reports/module"
      element={<ModuleCampusListing />}
    />,
    <Route
      key="module-listing"
      path="/admin/reports/module/:campusName"
      element={<ModuleListing />}
    />,
    <Route
      key="module-report"
      path="/admin/reports/module/:campusName/:moduleId"
      element={<ModuleReport />}
    />,
    <Route
      key="module-not-attended"
      path="/admin/reports/module/:campusName/:moduleId/not-attended"
      element={<ModuleNotAttended />}
    />,
    <Route
      key="module-detailed-report"
      path="/admin/reports/module/:campusName/:moduleId/report"
      element={<ReportList />}
    />,
  <Route
    key="assignment-not-attendee"
    path="/admin/reports/assignments/:campusName/:assignment_id/notAttendee"
    element={<AssignmentNotAttendee />}
  />,
  <Route
    key="reports-cluster-listing"
    path="admin/reports/course/:campusName"
    element={<ReportsClusterListing />}
  />,
  <Route
    key="cluster-report"
    path="admin/reports/course/:campusName/:clusterId"
    element={<ClusterReport />}
  />,
  


];

export default adminRoutes;
